import React from 'react';
import { AppFeature } from '../../types';
import { useI18n } from '../../context/I18nContext';
import { Badge } from '../ui/Badge';
import { CheckCircle2 } from 'lucide-react';

export interface FeatureListProps {
  features: AppFeature[];
}

export const FeatureList: React.FC<FeatureListProps> = ({ features }) => {
  const { resolveText } = useI18n();

  if (!features || features.length === 0) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
      {features.map((feat) => (
        <div
          key={feat.id}
          className="bg-white border border-slate-200/90 rounded-2xl p-6 shadow-xs hover:border-slate-300 transition-colors flex flex-col justify-between"
        >
          <div>
            <div className="w-10 h-10 rounded-xl bg-primary-50 text-primary-700 flex items-center justify-center mb-4 border border-primary-200/60">
              <CheckCircle2 className="w-5 h-5" />
            </div>

            {feat.badge && (
              <Badge variant="brand" size="sm" className="mb-2.5">
                {resolveText(feat.badge)}
              </Badge>
            )}

            <h4 className="text-lg font-bold text-slate-900 tracking-tight mb-2">
              {resolveText(feat.title)}
            </h4>
            <p className="text-sm text-slate-600 leading-relaxed">
              {resolveText(feat.description)}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};
